import { useQuery } from "react-query";
import { useClient } from "../hooks";

export const useOrganisationsQuery = (config) => {
  const client = useClient();

  return useQuery({
    queryKey: "connected_organisations",
    queryFn: async () => {
      return client.get("connected_organisations").get("data");
    },
    ...(config ?? {}),
  });
};
